import axios from 'axios'
import router from '@/router/index.js'
import { Toast } from 'vant'
import { ApiToken } from './ApiToken.js'


const service = axios.create({
    // 公共接口--这里注意后面会讲
    baseURL: process.env.NODE_ENV === 'production' ? ApiToken.baseUrl : '/',
    // baseURL: ApiToken.baseUrl,
    timeout: 120000,
})

// // 发布后调用接口需要使用
// if (process.env.NODE_ENV === 'production') {
//   service.defaults.baseURL = '' //正式
// }else{
//   // service.defaults.baseURL = ''
// }

service.interceptors.request.use(
    config => {
        if (config.type == 'out') {
            config.headers['Content-Type'] = 'x-www-form-urlencoded;charset=UTF-8'
        } else if (config.type == 'live') {
            config.headers['Authorization'] = config.params.token
        } else {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        console.log(error);
        switch (error.response.status) {
            case 400:
                Toast('请求数据格式不正确!')
                break
            case 401:
                Toast('当前处于未登录状态，请先登录重试!')
                localStorage.removeItem(ApiToken.token)
                router.push('/Login')
                break
            case 402:
                break
            case 403:
                Toast('页面访问权限不足!已返回首页')
                localStorage.removeItem(ApiToken.token)
                // router.push('/Home/Index')
                break
            case 404:
                break
            case 415:
                Toast('请求数据格式不正确!')
                break
            case 500:
                localStorage.removeItem(ApiToken.token)
                break
        }
        return Promise.reject(error.response.status)
    }
)


export default service